export const setPrimaryColor = () => {
  const { pathname } = window.location;

  if (pathname.includes("admin")) {
    document.documentElement.style.setProperty("--primary-color", "#1ab9de");
  } else {
    document.documentElement.style.setProperty("--primary-color", "#1890ff");
  }
};
